<template>
	<div v-cloak>
		<button :class="styling" ref="btnFacebookLogin" @click="facebookLoginButtonClick">
			<img :src="urlButtonIcon" />
			<span>Sign in with Facebook</span>
		</button>
		<div class="mt-1 mb-3 text-center" ref="divFacebookLogin" v-show="error">
			<span class="error-msg">Could not sign in with Facebook. Please <a href="/contact" rel="nofollow" target="_blank">contact support</a> if this keeps happening.</span>
		</div>
	</div>
</template>




<script>
	// This components depends on:
	// https://connect.facebook.net/en_US/sdk.js
	// <link href="https://fonts.googleapis.com/css2?family=Roboto&display=swap" rel="stylesheet">

	export default {
		mixins: [mixinAxios],
		data: () => ({
			error : false
		}),
		props: {
			appId       : { type: String, required: true },
			version     : { type: String, required: true },
			styling     : { type: String, default: 'styling0' },
			urlRedirect : { type: String, default: null },
			width       : { type: Number, default: 300 }

		},
		mounted() {
			this.setWidth();
			window.fbAsyncInit = this.initFacebookJavascriptSDK();
		},
		methods: {
			setWidth() {
				var width = common.parseWidthValue(this.width);
				this.btnFacebookLogin.style.width = width;
				this.divFacebookLogin.style.width = width;
			},
			redirect() {
				var redirectionNotNull = (this.redirectionUrl != null);

				if (redirectionNotNull) {
					window.location.href = this.redirectionUrl;
				} else {
					window.location.reload();
				}
			},
			debugToken(response) {
				// todo: use /debug_token to create complete facebook access token object, just like the google button does
				FB.api('/debug_token', { 'input_token': response.authResponse.accessToken }, (resDebugToken) => {
					if (resDebugToken && !resDebugToken.error) {
						// handle result
					} else {
						// error message
						console.log('error in debugToken()');
					}

					console.log('debug_token', response2);
				});
			},
			getLoginStatus() {
				FB.getLoginStatus(function(response) {
					if (response.status === 'connected') {
						// The user is logged in and has authenticated your
						// app, and response.authResponse supplies
						// the user's ID, a valid access token, a signed
						// request, and the time the access token
						// and signed request each expire.
						var uid = response.authResponse.userID;
						var accessToken = response.authResponse.accessToken;
					} else if (response.status === 'not_authorized') {
						// The user hasn't authorized your application.  They
						// must click the Login button, or you must call FB.login
						// in response to a user gesture, to launch a login dialog.
					} else {
						// The user isn't logged in to Facebook. You can launch a
						// login dialog with a user gesture, but the user may have
						// to log in to Facebook before authorizing your application.
					}
				}, true);
			},
			_facebookLoginAttempt(response) {
				var facebookAccessToken = {
					accessToken : response?.authResponse?.accessToken,
				};

				var signInInfo = {
					facebookAccessToken : facebookAccessToken,
					clientDateTime      : common.getClientDateTimeString()
				};

				return this.mixinAxios().post('/api/guest/FacebookLoginAttempt', signInInfo)
					.then((resFacebookLoginAttempt) => {
							if (resFacebookLoginAttempt.data.success) {
								this.redirect();
							} else {
								this.error = true;
							}
						})
					.catch(() => {
						this.error = true;
					});
			},
			facebookLoginAttempt(response) {
				if (response.status == 'connected') {
					this._facebookLoginAttempt(response);
				} else if (response.status == 'not_authorized') {
					this.error = true;
				} else if (response.status == 'unknown') {
					this.error = true;
				} else {
					this.error = true;
				}
			},
			//logFbSdkResponse(desc, obj) {
			//	var fbSdkLog = {
			//		desc : desc,
			//		json : JSON.stringify(obj)
			//	};

			//	return this.mixinAxios().post('/api/guest/LogFbSdkLog', fbSdkLog);
			//},
			facebookLoginCallback(response) {
				//this.logFbSdkResponse('FB.login() response.', response)
				//	.then(() => {
				//		this.facebookLoginAttempt(response);
				//	});

				this.facebookLoginAttempt(response);
			},
			facebookLogin() {
				FB.login(
					this.facebookLoginCallback,
					{
						scope: 'email,public_profile',
						return_scopes: true
					}
				);
			},
			facebookLoginButtonClick() {
				//this.error = false;
				//this.logFbSdkResponse('FB.login() initiated.')
				//	.then(() => {
				//		this.facebookLogin();
				//	});

				this.error = false;
				this.facebookLogin();
			},
			initFacebookJavascriptSDK() {
				FB.init({
					appId: this.appId,
					autoLogAppEvents: true,
					xfbml: true,
					version: this.version
				});
			}
		},
		computed: {
			btnFacebookLogin() {
				return this.$refs['btnFacebookLogin'];
			},
			divFacebookLogin() {
				return this.$refs['divFacebookLogin'];
			},
			urlButtonIcon() {
				switch (this.styling)
				{
					case 'styling0' : return '/img/login-buttons/facebook/icon-facebook-inverted.svg';
					case 'styling1' : return '/img/login-buttons/facebook/icon-facebook.svg';
					default         : return '/img/login-buttons/facebook/icon-facebook.svg';
				}
			},
			redirectionUrl() {
				var urlFromParam = common.getUrlParameterByName('redirect');

				return (urlFromParam != null)
					? urlFromParam
					: (this.urlRedirect != null)
					? this.urlRedirect
					: null;
			}
		},
		watch: {
			width(newVal, oldVal) {
				this.setWidth();
			}
		}
	};
</script>




<style scoped>
	[v-cloak] {
		display:none;
	}


	/* common */

	.error-msg {
		color: red;
	}

	/* common */


	/* styling 0 */

	.styling0 {
		font-family: 'Roboto', sans-serif;
		font-weight: normal;
		font-size: 16px;
		color: #FFFFFF;
		height: 40px;
		background: #4267B2;
		padding:0px 12px;
		display:flex;
		align-items:center;
		justify-content:center;
		border:thin solid #4267B2;
		border-radius: 4px;
		cursor:pointer;
	}

	.styling0 img {
		height:22px;
		width:22px;
	}

	.styling0 span {
		margin:3px 0px 0px 10px;
	}

	/* styling 0 */


	/* styling 1 */

	.styling1 {
		font-family: 'Roboto', sans-serif;
		font-weight: normal;
		font-size: 16px;
		color: #4C4C4C;
		height: 44px;
		background: #FFFFFF;
		padding:0px 12px;
		display:flex;
		align-items:center;
		justify-content:center;
		border:thin solid #C0C0C0;
		border-radius: 4px;
		cursor:pointer;
	}

	.styling1 img {
		height:22px;
		width:22px;
	}

	.styling1 span {
		margin:3px 0px 0px 10px;
	}

	/* styling 1 */

</style>